import React from 'react';
import { Panel, Empty, StatusBadge } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { fmtUsd, fmtDate } from '../../lib/api';

export default function Settlements() {
  const { data: list } = useFetch('/settlements', [], 30000);
  return (
    <div data-testid="settlements-page">
      <Panel title="Daily Settlement Statements">
        {list && list.length ? (
          <div className="space-y-3">
            {list.map((s) => (
              <div key={s.id} className="rounded-lg border border-border p-4">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs text-vj-grey">{fmtDate(s.created_at)}</span>
                  <StatusBadge status={s.status} />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                  <div><div className="text-xs text-vj-grey">Opening</div><div className="font-mono">{fmtUsd(s.opening_balance)}</div></div>
                  <div><div className="text-xs text-vj-grey">Gross P&L</div><div className={`font-mono ${Number(s.gross_pnl) >= 0 ? 'text-vj-neon' : 'text-vj-red'}`}>{fmtUsd(s.gross_pnl)}</div></div>
                  <div><div className="text-xs text-vj-grey">Fees</div><div className="font-mono text-vj-grey">{fmtUsd(s.fees)}</div></div>
                  <div><div className="text-xs text-vj-grey">Closing</div><div className="font-mono">{fmtUsd(s.closing_balance)}</div></div>
                </div>
                <div className="mt-2 text-[11px] text-vj-gold">Source: {s.source}</div>
              </div>
            ))}
          </div>
        ) : <Empty>No settlements posted yet. Settlements are posted by the daily settlement scheduler.</Empty>}
      </Panel>
    </div>
  );
}
